import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import useAppContext from '../../hooks/useAppContext';
import { classes, Root } from './styles';

const Minimal = (props) => {
  const {
    children,
  } = props;

  const { currentEnv } = useAppContext();

  return (
    <Root className={classes.root}>
      <main className={classes.content}>
        {children}
        {currentEnv === 'DEV' && <footer className={classes.devText}><Trans>DEV ENV</Trans></footer>}
      </main>
    </Root>
  );
};

Minimal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Minimal;
